module.exports = __webpack_public_path__ + "img/game01.f0097c27.png";